import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { IoClose } from "react-icons/io5";
import "../styles/_datepicker.scss";
import CustomDatePicker from "./CustomDatePicker";
import axios from "axios";
import ImageLoading from "./ImageLoading";
import VanishComponent from "./VanishComponent";

function BsaDateSelect({ setShowModal, downLoadType, id }) {
  const [timeSelect, setTimeSelect] = useState("period");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [error, setError] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const handleRadioChange = (e) => {
    setError(null);
    setTimeSelect(e.target.value);
    setSelectedPeriod("");
    setStartDate(null);
    setEndDate(null);
  };

  const handleDate = (value) => {
    setError(null);
    let startDate1 = null;
    let endDate1 = null;
    const getStartDate = (daysAgo) => {
      const date = new Date();
      date.setDate(date.getDate() - daysAgo);
      return date;
    };

    switch (value) {
      case "This Month":
        startDate1 = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        endDate1 = new Date();

        break;

      case "Previous Month":
        startDate1 = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        );
        endDate1 = new Date(new Date().getFullYear(), new Date().getMonth(), 0);

        break;
      case "Last 60 days":
        startDate1 = getStartDate(60);
        endDate1 = new Date();
        break;
      case "Last 90 days":
        startDate1 = getStartDate(90);
        endDate1 = new Date();
        break;
      case "Last 180 days":
        startDate1 = getStartDate(180);
        endDate1 = new Date();
        break;
      case "Current Year":
        startDate1 = new Date(new Date().getFullYear(), 0, 1);
        endDate1 = new Date();
        break;
      case "2023":
        startDate1 = new Date("2023-01-01");
        endDate1 = new Date("2023-12-31");
        break;
      case "2022":
        startDate1 = new Date("2022-01-01");
        endDate1 = new Date("2022-12-31");
        break;
      default:
        console.warn("Unknown period selected");
    }

    setStartDate(formatDate(startDate1));
    setEndDate(formatDate(endDate1));
  };

  const formatDate = (dateFormat) => {
    console.log(dateFormat);

    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    return ans;
  };
  const periodValues = [
    {
      value: "This Month",
      label: "This Month",
    },
    {
      value: "Previous Month",
      label: "Previous Month",
    },
    {
      value: "Last 60 days",
      label: "Last 60 days",
    },
    {
      value: "Last 90 days",
      label: "Last 90 days",
    },
    {
      value: "Last 180 days",
      label: "Last 180 days",
    },
    {
      value: "Current Year",
      label: "Current Year",
    },
    {
      value: "2023",
      label: "2023",
    },
    {
      value: "2022",
      label: "2022",
    },
  ];
  const handleClear = () => {
    setSelectedPeriod("");
    setStartDate(null);
    setEndDate(null);
  };

  const downloadConsolidatedReport = async () => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${
          process.env.REACT_APP_URL
        }/lender/v1/user_consent_summary_report?report_type=${downLoadType}&start_date=${startDate}&end_date=${endDate}${
          downLoadType === "individual" ? `&user_uuid=${id}` : ""
        }`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.response.status) {
        const url = res.data.response.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      if (error.response.status === 404) {
        setNoData(true);
      }
    } finally {
      setDownloadLoading(false);
    }
  };
  const downloadConsolidatedReportCustom = async () => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${
          process.env.REACT_APP_URL
        }/lender/v1/user_consent_summary_report?report_type=${downLoadType}&start_date=${formatDate(
          startDate
        )}&end_date=${formatDate(endDate)}${
          downLoadType === "individual" ? `&user_uuid=${id}` : ""
        }`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.response.status) {
        const url = res.data.response.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      if (error.response.status === 404) {
        setNoData(true);
      }
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const dateValidation = (timeSelect) => {
    if (!startDate || !endDate) {
      setError("Please select a date range");
      return;
    }

    if (timeSelect !== "custom") {
      downloadConsolidatedReport();
      return;
    }

    if (startDate > endDate) {
      setError("Start date cannot be greater than end date");
    } else if (endDate > new Date()) {
      setError("End date cannot be greater than today");
    } else {
      // setStartDate(formatDate(startDate));
      // setEndDate(formatDate(endDate));

      if (timeSelect === "custom") {
        downloadConsolidatedReportCustom();
        return;
      }
      downloadConsolidatedReport();
    }
  };
  return (
    <>
      <div className="overlay z-50">
        <div
          className={`modal !w-[445px]  !justify-normal  !p-0 !text-left !flex-col ${
            timeSelect === "period" ? "!min-h-[345px]" : " !min-h-[297px] "
          } ${error !== null ? "!h-[320px]" : " "} `}
        >
          {downloadLoading && (
            <div className=" w-full h-full flex justify-center items-center">
              <ImageLoading />
            </div>
          )}
          {!downloadLoading && (
            <>
              <div className=" w-full bg-[#f3f3f3] py-[10.5px] flex justify-between px-6 rounded-t items-center">
                <p className=" text-base font-bold">Consent Summary History</p>
                <button onClick={() => setShowModal(false)}>
                  <IoClose size={23} />
                </button>
              </div>
              <div className=" w-full px-6 mt-[14px]">
                <div className=" flex justify-between items-center text-sm text-[#848484] font-medium">
                  <p>Select Time</p>
                  <button onClick={() => handleClear()}>Clear</button>
                </div>
                <div className=" mt-4 text-sm flex items-center font-medium checked:bg-emerald-400">
                  <input
                    checked={timeSelect === "period"}
                    type="radio"
                    value="period"
                    name="time"
                    id="period"
                    className=" mr-3 size-4"
                    onChange={handleRadioChange}
                  />
                  <label for="period">Period</label>
                  <input
                    checked={timeSelect === "custom"}
                    type="radio"
                    value="custom"
                    name="time2"
                    id="custom"
                    className=" mr-3 ml-[27px] size-4"
                    onChange={handleRadioChange}
                  />
                  <label for="custom">Custom Date range</label>
                </div>
                {timeSelect === "period" && (
                  <div className=" flex flex-wrap font-medium text-sm l mt-6 ">
                    {periodValues.map((item, index) => (
                      <button
                        onClick={() => {
                          setSelectedPeriod(item.value);
                          handleDate(item.value);
                        }}
                        className={`  px-3 mt-3 rounded eading-[14px] h-[30px]  ${
                          index % 3 === 1 ? " mx-[15px]" : ""
                        } ${
                          selectedPeriod === item.value
                            ? "bg-[#a0ff77] "
                            : "hover:bg-[#9caaaf] bg-[#f3f3f3]"
                        } `}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                )}
                {timeSelect === "custom" && (
                  <div className=" font-medium text-sm mt-9  flex  ">
                    <div>
                      <label className=" block mb-2 ">From:</label>
                      <CustomDatePicker
                        date={startDate}
                        setDate={setStartDate}
                        setError={setError}
                      />
                    </div>
                    <div className=" ml-4">
                      <label className="block mb-2 ">To:</label>
                      <CustomDatePicker
                        date={endDate}
                        setDate={setEndDate}
                        setError={setError}
                      />
                    </div>
                  </div>
                )}
                <div></div>
                {error && (
                  <p className="text-[11px] text-red-500 mt-2 font-medium pl-1">
                    {error}
                  </p>
                )}
                <button
                  onClick={() => dateValidation(timeSelect)}
                  className="text-sm font-semibold py-[6px] px-4 flex  mt-4 mb-4 items-center bg-[#00394d] text-white ml-auto rounded"
                >
                  Download
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <VanishComponent
        error={noData}
        errorFunction={() => {
          setNoData(false);
        }}
        errorMessage={`No records found`}
        timeOut={5000}
      />
    </>
  );
}

export default BsaDateSelect;
